export const SYSTEM_HEALTH_CONFIG = {
    ONLINE: {
        label: "Online",
        color: "#065F46", bg: "#ECFDF5", border: "#A7F3D0", dot: "#10B981",
        iconName: "solar:server-bold",
        pulse: true,
    },
    OFFLINE: {
        label: "Offline",
        color: "#374151", bg: "#F9FAFB", border: "#E5E7EB", dot: "#9CA3AF",
        iconName: "solar:server-square-cloud-bold",
    },
    DEGRADED: {
        label: "Degraded",
        color: "#92400E", bg: "#FFFBEB", border: "#FDE68A", dot: "#F59E0B",
        iconName: "solar:danger-triangle-bold",
    },
    MAINTENANCE: {
        label: "Maintenance",
        color: "#1E40AF", bg: "#EFF6FF", border: "#BFDBFE", dot: "#3B82F6",
        iconName: "solar:settings-minimalistic-bold",
    },
    INCIDENT: {
        label: "Incident",
        color: "#991B1B", bg: "#FFF1F2", border: "#FECDD3", dot: "#F43F5E",
        iconName: "solar:bell-bing-bold",
    },
};